import { Injectable } from '@angular/core';
import { EnvConfigurationService } from '../envconf/envconf.service';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { DistributorStockDto, DistributorStockNoIdDto } from '../../models/distributor/distributor-stock-dto';
import { PaginatedResponse, PaginatorFilters } from '@michelin/theme';
import { Pagination } from '../../models/pagination';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class DistributorStockService {
  endpoint = `${EnvConfigurationService.configuration.BACKEND_URL}${EnvConfigurationService.configuration.BACKEND_SUB_PATH}/distributors/stock/products`;

  constructor(private readonly http: HttpClient, private readonly apiService: ApiService) {}

  getPaginatedResponse(pagination: Pagination<DistributorStockDto>): PaginatedResponse<DistributorStockDto> {
    return {
      count: pagination.totalElements,
      items: pagination.content
    };
  }

  search(paginatorFilters?: PaginatorFilters): Observable<PaginatedResponse<DistributorStockDto>> {
    return this.http
      .get<PaginatedResponse<DistributorStockDto>>(`${this.endpoint}/search${this.apiService.getQueryParams(paginatorFilters)}`)
      .pipe(map((items: Pagination<DistributorStockDto>) => this.getPaginatedResponse(items)));
  }

  findAll(): Observable<DistributorStockDto> {
    return this.http.get<DistributorStockDto>(`${this.endpoint}`);
  }

  create(data: DistributorStockNoIdDto): Observable<DistributorStockDto> {
    return this.http.post<DistributorStockDto>(this.endpoint, data);
  }

  update(distributorStockId: number, data: DistributorStockNoIdDto): Observable<DistributorStockDto> {
    return this.http.put<DistributorStockDto>(`${this.endpoint}/${distributorStockId}`, data);
  }
}
